// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Instagram: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36">
            <g fill="none" fillRule="evenodd">
                <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M18.002 13.897a4.095 4.095 0 0 0-4.101 4.101A4.095 4.095 0 0 0 18 22.1a4.095 4.095 0 0 0 4.102-4.1 4.095 4.095 0 0 0-4.101-4.102zm0 6.768a2.671 2.671 0 0 1-2.667-2.667 2.669 2.669 0 0 1 2.667-2.666 2.669 2.669 0 0 1 2.666 2.666c0 1.47-1.2 2.667-2.666 2.667zm5.225-6.936a.957.957 0 1 0-1.913 0 .957.957 0 0 0 1.913 0zm2.717.971c-.06-1.281-.354-2.416-1.292-3.352-.936-.935-2.07-1.228-3.352-1.292-1.32-.075-5.28-.075-6.6 0-1.278.06-2.413.354-3.352 1.289-.938.935-1.228 2.07-1.292 3.351-.075 1.321-.075 5.28 0 6.6.06 1.282.354 2.417 1.292 3.352.94.935 2.07 1.228 3.352 1.292 1.32.075 5.28.075 6.6 0 1.281-.06 2.416-.353 3.352-1.292.935-.935 1.228-2.07 1.292-3.352.075-1.32.075-5.275 0-6.596zm-1.706 8.013a2.7 2.7 0 0 1-1.521 1.521c-1.053.418-3.552.321-4.715.321-1.164 0-3.666.093-4.715-.321a2.7 2.7 0 0 1-1.521-1.52c-.418-1.054-.321-3.552-.321-4.716 0-1.163-.093-3.666.321-4.715a2.7 2.7 0 0 1 1.52-1.52c1.054-.418 3.552-.322 4.716-.322 1.163 0 3.666-.093 4.715.321a2.7 2.7 0 0 1 1.52 1.521c.418 1.053.322 3.552.322 4.715 0 1.164.096 3.666-.321 4.715z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Instagram);
